export default __webpack_public_path__ + "static/media/4_TempsChanson.68cc9eba.mp3";